import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography, } from '@mui/material';
import { makeStyles } from "../../util/tss-react/index.js";
const useStyles = makeStyles()(theme => ({
    expansionPanelDetails: {
        display: 'block',
        padding: theme.spacing(1),
    },
    icon: {
        color: theme.palette.tertiary.contrastText || '#fff',
    },
}));
export default function BaseCard({ children, title, defaultExpanded = true, }) {
    const { classes } = useStyles();
    return (_jsxs(Accordion, { defaultExpanded: defaultExpanded, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMore, { className: classes.icon }), children: _jsx(Typography, { variant: "button", children: title }) }), _jsx(AccordionDetails, { className: classes.expansionPanelDetails, children: children })] }));
}
